import { setInputFormattedValue } from '../../components/number-format-input';

export const initClearFilter = () => {
    const filterForm = document.getElementById('product-filter-form');

    const elements = document.querySelectorAll('.filtration-info__filters .filtration-info__item');

    if (filterForm === null) {
        return;
    }

    elements.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            if (typeof element.dataset.inputName === 'undefined') {
                filterForm.querySelectorAll('input[type=checkbox]').forEach((targetInput) => {
                    targetInput.checked = false;
                });

                filterForm.querySelectorAll('[data-filter-input-name]').forEach((targetSlider) => {
                    resetSlider(targetSlider, filterForm);
                });

                naja.uiHandler.submitForm(filterForm);

                // Vyprazdnime filtry
                element.parentElement.innerHTML = '';

                return;
            }

            let selector = '[name="' + element.dataset.inputName + '"]';

            if (typeof element.dataset.inputValue !== 'undefined') {
                selector += '[value="' + element.dataset.inputValue + '"]';
            }

            const targetInput = filterForm.querySelector(selector);

            if (targetInput === null) {
                const targetSlider = filterForm.querySelector(
                    '[data-filter-input-name="' + element.dataset.inputName + '"]'
                );

                if (targetSlider === null) {
                    return;
                }

                resetSlider(targetSlider, filterForm);

                naja.uiHandler.submitForm(filterForm);

                return;
            }

            targetInput.checked = false;
            targetInput.dispatchEvent(new Event('change'));

            // Odstranime tag hned primo js
            element.remove();
        });
    });
};

const resetSlider = (sliderElement, filterForm) => {
    const linkedInputFrom = filterForm.querySelector(sliderElement.dataset.linkedInputFromSelector);
    const linkedInputTo = filterForm.querySelector(sliderElement.dataset.linkedInputToSelector);

    if (linkedInputFrom !== null) {
        setInputFormattedValue(linkedInputFrom, sliderElement.dataset.sliderMin);
    }

    if (linkedInputTo !== null) {
        setInputFormattedValue(linkedInputTo, sliderElement.dataset.sliderMax);
    }

    const slider = window.bootstrapSliders[sliderElement.dataset.sliderInstanceIndex];

    if (slider === null) {
        return;
    }

    slider.setValue([parseInt(sliderElement.dataset.sliderMin), parseInt(sliderElement.dataset.sliderMax)]);
};
